const routes = [
  {
    path: 'verifier',
    name: 'verifier.admin',
    meta: {
      hide: true,
      requiresAuth: true,
    },
    component: () => import('@/modules/admin/verifier/layout/MainLayout.vue'),
    children: [
      {
        path: 'home',
        name: 'verifier.home.layout',
        // component: () =>
        //   import('@/modules/admin/modules/home/views/HomeView.vue'),
        children: [
          {
            path: '',
            name: 'verifier.home',
            component: () =>
              import(
                '@/modules/admin/verifier/modules/home/views/HomeView.vue'
              ),
          },
          {
            path: 'process',
            name: 'verifier.process.details',
            component: () =>
              import(
                '@/modules/admin/verifier/modules/home/modules/process/views/ProcessDetails.vue'
              ),
          },
          {
            path: 'finance',
            name: 'verifier.finance.details',
            component: () =>
              import(
                '@/modules/admin/verifier/modules/home/modules/finance/views/FinanceDetails.vue'
              ),
          },
        ],
      },
      {
        path: 'process',
        name: 'verifier.process',
        component: () =>
          import(
            '@/modules/admin/verifier/modules/process/views/BranchView.vue'
          ),
      },
      {
        path: 'branches',
        name: 'verifier.branches',
        component: () =>
          import(
            '@/modules/admin/verifier/modules/process/views/BranchView.vue'
          ),
      },
      {
        path: 'branches/:id',
        name: 'verifier.branches.details',
        component: () =>
          import(
            '@/modules/admin/verifier/modules/process/views/BranchDetailsView.vue'
          ),
      },
      {
        path: 'report',
        name: 'verifier.report',
        component: () =>
          import(
            '@/modules/admin/verifier/modules/reports/views/ReportView.vue'
          ),
      },
      {
        path: 'configs',
        name: 'verifier.config',
        component: () =>
          import(
            '@/modules/admin/verifier/modules/reports/views/ReportView.vue'
          ),
      },
    ],
  },
];

export default routes;
